import { Component } from '@angular/core';
import { LeaderboardType } from '@fgb/core';

@Component({
  selector: 'fgb-trivia-v2-leaderboard-page',
  templateUrl: './trivia-v2-leaderboard-page.component.html',
  styleUrl: './trivia-v2-leaderboard-page.component.scss',
})
export class TriviaV2LeaderboardPageComponent {
  LeaderboardType: LeaderboardType = LeaderboardType.TriviaPoints;
}
